module.exports = __webpack_public_path__ + "media/img/decorations/testing-myths-img-left-eb9a5c7f578f8807bf63c112b210c157.svg";